import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { TagComponent } from './tag/tag.component'
import { TagsComponent } from './tags.component'
import { RouterModule } from '@angular/router'
import { AnalyticsModule } from '../../shared/analytics/analytics.module'

@NgModule({
  imports: [CommonModule, RouterModule, AnalyticsModule],
  declarations: [TagComponent, TagsComponent],
  exports: [TagComponent, TagsComponent]
})
export class TagsModule {}
